// BD-1016: on/off chip for the dashboard-wide "exclude disabled users" filter.
// Styled to sit in the same row as FilterChip; filled when on. Pass value/onChange
// to drive local state instead (the export builder's own population filter).
import React from 'react';
import { Box, Tooltip } from '@mui/material';
import { useExcludeDisabled, setExcludeDisabled } from '../disabledFilter';
import { chipSx } from './MetaNav';

export default function DisabledFilterChip({ value, onChange }) {
    const globalOn = useExcludeDisabled();
    const controlled = typeof onChange === 'function';
    const on = controlled ? Boolean(value) : globalOn;
    const toggle = () => (controlled ? onChange(!on) : setExcludeDisabled(!on));
    // BD-1245: dashboard risk scores ignore the toggle; an export's own chip (controlled)
    // still applies to its risk sections.
    const tip = controlled
        ? (on ? 'Disabled users are excluded. Click to include them again.' : 'Remove disabled users from every figure and chart in this export.')
        : (on ? 'Disabled users are excluded, except from risk scores. Click to include them again.' : 'Remove disabled users from every figure and chart except risk scores.');
    return (
        <Tooltip title={tip}>
            <Box
                role="switch"
                aria-checked={on}
                tabIndex={0}
                id={controlled ? undefined : 'reports-exclude-disabled'}
                onClick={toggle}
                onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); } }}
                sx={{ ...chipSx(on), whiteSpace: 'nowrap' }}
            >
                Exclude disabled users
            </Box>
        </Tooltip>
    );
}
